import featureService from "./FeatureService";

export const QueryStringService = {
  getQueryString: function (params, filters, filterData) {
    if (params.has("keyword")) {
      filters.queryString = params.get("keyword");
      filterData.queryString = filters.queryString;
    }

    if (params.has("location")) {
      filters.location = params.get("location");
      filterData.location = filters.location;
    }

    if (params.has("distance") && params.has("location")) {
      filters.distance = params.get("distance");
      filterData.distance = filters.distance;
    }
    
    Array.from({ length: 4 }, (_, i) => i + 1).map((i) => {
      const currentCustomStringAttributes = `customStringAttributes${i}`;
      if (
        featureService.isAllowed(["cMp8rdyHb2"]) &&
        filterData &&
        filterData[currentCustomStringAttributes] &&
        filterData[currentCustomStringAttributes].predefinedId &&
        params.has(filterData[currentCustomStringAttributes].predefinedId)
      ) {
        const values = params
          .get(filterData[currentCustomStringAttributes].predefinedId)
          .split(",");
        if (values.length) {
          filters[currentCustomStringAttributes] = [];
          values.forEach((value) => {
            const found = filterData[
              currentCustomStringAttributes
            ].result?.find((item) => {
              return item.predefinedId === value;
            });
            if (found) {
              found.active = true;
              filters[currentCustomStringAttributes].push(found);
            }
          });
        }
      } else if (
        filterData &&
        filterData[currentCustomStringAttributes] &&
        filterData[currentCustomStringAttributes].slug &&
        params.has(filterData[currentCustomStringAttributes].slug)
      ) {
        const values = params
          .get(filterData[currentCustomStringAttributes].slug)
          .split(",");
        if (values.length) {
          filters[currentCustomStringAttributes] = [];
          values.forEach((value) => {
            const found = filterData[
              currentCustomStringAttributes
            ].result?.find((item) => {
              return item.id === value;
            });
            if (found) {
              found.active = true;
              filters[currentCustomStringAttributes].push(found);
            }
          });
        }
      }
      return 0;
    });

    if (params.has("type")) {
      filters.jobTypes = [];
      var keys = params.get("type").split(",");
      keys.forEach((key) => {
        var foundType = filterData.jobTypes?.find((type) => {
          return type.key === key;
        });
        if (foundType) {
          foundType.active = true;
          filters.jobTypes.push(foundType);
        }
      });
    }

    if (params.has("salary")) {
      filters.salary = {};
      var salary = params.get("salary").split("|");
      if (salary.length === 5) {
        filters.salary.type = filterData.salary?.types.find(
          (x) => x.id === salary[0],
        );

        filters.salary.type = {
          id: salary[0],
          name: salary[1],
          key: salary[2],
        };
        filters.salary.minimum = salary[3];
        filters.salary.currencyCode = salary[4];
      }
    }

    if (params.has("remote")) {
      filters.remoteWorking = params.get("remote") === "true" ? true : false;
      filterData.remoteWorking = filters.remoteWorking;
    }

    if (params.has("commute")) {
      var commute = params.get("commute").split("|");
      filters.commute = {};
      filters.commute.method = { id: parseInt(commute[0]), name: commute[1] };
      filters.commute.startingLocation = {
        latlng: { lat: commute[3], lng: commute[4] },
        name: commute[2],
      };
      filters.commute.travelTime = commute[5];

      filterData.commute = filters.commute;
    }
  },
  setQueryString: function (params, filters, originalFilters) {
    params.delete("keyword");
    params.delete("location");
    params.delete("distance");
    params.delete("type");
    params.delete("sector");

    if (filters.queryString)
      params.set("keyword", filters.queryString);

    if (filters.location)
      params.set("location", filters.location);

    if (
      filters.distance !== undefined &&
      filters.location !== undefined &&
      filters.location !== ""
    )
      params.set("distance", filters.distance);

    if (filters.customStringAttributes?.length)
      params.set(
        "sector",
        filters.customStringAttributes?.map((x) => x?.id).join(","),
      );

    if(featureService.isAllowed(["cMp8rdyHb2"])) {
      Array.from({ length: 4 }, (_, i) => i + 1).map((i) => {
        const currentCustomStringAttributes = `customStringAttributes${i}`;
  
        if (
          originalFilters &&
          originalFilters[currentCustomStringAttributes] &&
          originalFilters[currentCustomStringAttributes].slug
        )
          params.delete(originalFilters[currentCustomStringAttributes].slug);
  
        if (filters[currentCustomStringAttributes]?.length)
          params.set(
            originalFilters[currentCustomStringAttributes].slug,
            filters[currentCustomStringAttributes]?.map((x) => x ? x.id + "," + x.predefinedId : "").join(","),
          );
  
        return 0;
      });
    } else {
      Array.from({ length: 4 }, (_, i) => i + 1).map((i) => {
        const currentCustomStringAttributes = `customStringAttributes${i}`;  
        if (
          originalFilters &&
          originalFilters[currentCustomStringAttributes] &&
          originalFilters[currentCustomStringAttributes].slug
        )
          params.delete(originalFilters[currentCustomStringAttributes].slug);
  
        if (filters[currentCustomStringAttributes]?.length)
          params.set(
            originalFilters[currentCustomStringAttributes].slug,
            filters[currentCustomStringAttributes]?.map((x) => x?.id).join(","),
          );
  
        return 0;
      });
    }

    if (filters.jobTypes?.length)
      params.set("type", filters.jobTypes?.map((x) => x?.key).join(","));

    if (filters.salary?.type?.id)
      params.set(
        "salary",
        filters.salary.type.id +
          "|" +
          filters.salary.type.name +
          "|" +
          filters.salary.type.key +
          "|" +
          filters.salary.minimum +
          "|" +
          filters.salary.currencyCode,
      );

    if (filters.commute?.method?.id)
      params.set(
        "commute",
        filters.commute.method.id +
          "|" +
          filters.commute.method.name +
          "|" +
          filters.commute.startingLocation?.name +
          "|" +
          filters.commute.startingLocation?.latlng?.lat +
          "|" +
          filters.commute.startingLocation?.latlng?.lng +
          "|" +
          filters.commute.travelTime,
      );

    if (filters.remoteWorking) {
      params.set("remote", true);
    } else {
      params.delete("remote");
    }
  },
};

export default QueryStringService;
